import React from 'react';
import Editor from 'react-simple-code-editor';
import Prism from 'prismjs';
import 'prismjs/components/prism-python';
import 'prismjs/themes/prism.css';
import 'react-simple-code-editor/lib/index.css'; // <-- Add this

const highlightCode = (code) => {
  return Prism.highlight(code, Prism.languages.python, 'python')
};

const PythonCodeEditor = ({ value, onChange, lang }) => {
  const codeValue = value || '';
  const lines = codeValue?.split('\n').length;

  return (
    <div style={{ display: 'flex', background: '#f8f8f8', borderRadius: 4, border: '1px solid #ccc' }}>
      <div
        style={{
          padding: '12px 8px',
          background: '#f0f0f0',
          color: '#888',
          fontFamily: 'monospace',
          fontSize: 14,
          textAlign: 'right',
          userSelect: 'none',
          borderTopLeftRadius: 4,
          borderBottomLeftRadius: 4,
        }}
      >
        {Array.from({ length: lines }, (_, i) => (
          <div key={i} style={{ height: '1.5em', lineHeight: '1.5em' }}>{i + 1}</div>
        ))}
      </div>
      <Editor
        value={value || ''}
        onValueChange={onChange}
        highlight={highlightCode}
        padding={12}
        style={{
          minHeight: '120px',
          fontFamily: 'monospace',
          fontSize: 14,
          backgroundColor: '#f8f8f8',
          color: '#2d2d2d',
          borderRadius: 0,
          border: 'none',
          width: '100%',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
        placeholder={
          lang === 'eng'
            ? 'Enter contextual code'
            : 'Enter condition code'
        }
        aria-label="Python code editor"
      />
    </div>
  )
}

export default PythonCodeEditor;